module.exports = __webpack_public_path__ + "static/media/gasAnimation.23044aaa.gif";